import React from 'react';
import { FieldTitleProps } from '../../../types/DesignSystem/FieldTitle';
import Typography from '../Typography/Typography';
import OverlayIcon from 'Components/GMS/Rules/Components/OverlayIcon';

const FieldTitle: React.FC<FieldTitleProps> = ({
  label,
  required = false,
  className = '',
  infoMessage = '',
}) => {
  return (
    <div className={className}>
      <Typography variant="title" className="tw-text-grey-900 tw-inline-flex tw-items-center tw-gap-1">
        {label}
        {required && <span className="tw-text-red-error-900">*</span>}
        {infoMessage && <OverlayIcon message={infoMessage} placement="top" />}
      </Typography>
    </div>
  );
};

export default FieldTitle;